module.exports = __webpack_public_path__ + "static/img/QR_tiktok.3c12964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QR_tiktok.png
// module id = 9fOE
// module chunks = 1